<template>
  <div class="">
    <h2 class="page_title ab c5a">インボイス登録番号</h2>
    <div class="mt12 pt16 pb16">
      <div class="bdb">
        <p class="rb">T{{ invoiceNumber }}</p>
      </div>
    </div>
    <div class="">
      <p class="invoice_text ab color_red">課税事業者の方（インボイス発行事業者）は、税務署より発行された「インボイス発行事業者登録番号（適格請求書発行事業者登録番号）」（Tから始まる13桁の数字）を登録してください。</p>
      <div class="mt24">
        <button @click="editInvoiceNumber" type="button" name="button" class="btn btn_yellow">編集</button>
      </div>
      <div class="mt24" v-if="invoiceNumber">
        <button type="button" name="button" class="btn btn_red" @click.prevent="openDeleteConfirm">削除</button>
      </div>
    </div>

    <BaseModal v-if="deleteConfirmOpen" @closeModal="closeDeleteConfirm">
      <p class="confirm_msg ab">インボイス登録番号を削除してもよろしいですか？</p>
      <div class="confirm_actions mt24">
        <BaseBtn :btnText="'キャンセル'" :type="'delete'" @onClick="closeDeleteConfirm" />
        <BaseBtn :style="{ marginTop: '16px' }" :btnText="'削除する'" :type="'blue'" @onClick="confirmDeleteAndEmit" />
      </div>
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from '@/components/common/BaseModal.vue';
import BaseBtn from '@/components/common/BaseBtn.vue';

export default {
  props: ['invoiceNumber'],
  components: {
    BaseModal,
    BaseBtn,
  },
  data() {
    return {
      deleteConfirmOpen: false,
    };
  },
  methods: {
    editInvoiceNumber() {
      this.$emit('editInvoiceNumber');
    },
    openDeleteConfirm() {
      this.deleteConfirmOpen = true;
    },
    closeDeleteConfirm() {
      this.deleteConfirmOpen = false;
    },
    confirmDeleteAndEmit() {
      this.deleteConfirmOpen = false;
      this.$emit('deleteInvoiceNumber');
    },
  }
}
</script>

<style lang="css" scoped>
.color_red {
  color: #FF3A3A;
}

.confirm_msg {
  font-size: 14px;
  line-height: 1.5;
}

.confirm_actions >>> .btn {
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/member/invoice/GetInvoiceNumber.vue